import gql from 'graphql-tag'

export const generalSettingFragment = gql`
    fragment generalSettingFragment on GeneralSetting {
        #id
        key
        name
        value
    }
`
export const generalSettingExtendedFragment = gql`
    fragment generalSettingExtendedFragment on GeneralSettingExtended {
        #id
        key
        name
        value
        description
        input
        defaultValue
        options
        values {
            label
            value
        }
        errorMSG
        allowNull
        dependsOn
        validate
        prefix
        suffix
    }
`